<template>
  <div class="v-interview-setting">
    <b-card class="v-interview-setting__card">
      <div class="row v-interview-setting__card__header">
        <div class="col-6 text-right">
          <h3>تنظیمات قرارها</h3>
        </div>
        <div class="col-6">
          <!-- <b-button size="sm" variant="primary" @click="modalShow = !modalShow">اضافه کردن پشتیبان</b-button> -->
        </div>
      </div>

      <hr class="mt-3 mb-3" />

      <b-form class="text-right" @submit="onSubmit">
        <b-form-group
          id="input-group-workingSaturday"
          label="ساعت های کاری شنبه ها:"
          label-for="input-workingSaturday"
        >
          <b-form-input
            id="input-workingSaturday"
            v-model="times.workingSaturday"
            placeholder="ساعت های کاری شنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingSunday"
          label="ساعت های کاری یکشنبه ها:"
          label-for="input-workingSunday"
        >
          <b-form-input
            id="input-workingSunday"
            v-model="times.workingSunday"
            placeholder="ساعت های کاری یکشنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingMonday"
          label="ساعت های کاری دوشنبه ها:"
          label-for="input-workingMonday"
        >
          <b-form-input
            id="input-workingMonday"
            v-model="times.workingMonday"
            placeholder="ساعت های کاری دوشنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingTuesday"
          label="ساعت های کاری سه شنبه ها:"
          label-for="input-workingTuesday"
        >
          <b-form-input
            id="input-workingTuesday"
            v-model="times.workingTuesday"
            placeholder="ساعت های کاری سه شنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingWednesday"
          label="ساعت های کاری چهارشنبه ها:"
          label-for="input-workingWednesday"
        >
          <b-form-input
            id="input-workingWednesday"
            v-model="times.workingWednesday"
            placeholder="ساعت های کاری چهارشنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingThursday"
          label="ساعت های کاری پنجشنبه ها:"
          label-for="input-workingThursday"
        >
          <b-form-input
            id="input-workingThursday"
            v-model="times.workingThursday"
            placeholder="ساعت های کاری پنجشنبه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-workingFriday"
          label="ساعت های کاری جمعه ها:"
          label-for="input-workingFriday"
        >
          <b-form-input
            id="input-workingFriday"
            v-model="times.workingFriday"
            placeholder="ساعت های کاری جمعه ها"
            required
          >
          </b-form-input>
        </b-form-group>

        <b-button type="submit" variant="primary">ثبت</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Interview from "@/httpservices/Interview";
import AddAgentForm from "@/components/AddAgentForm.vue";

export default {
  name: "InterviewSetting",
  components: {
    AddAgentForm,
  },

  data() {
    return {
      agents: [],
      modalShow: false,
      loading: true,
      isEdit: false,
      editAgentId: "",

      times: {
        workingSaturday: "",
        workingSunday: "",
        workingMonday: "",
        workingTuesday: "",
        workingWednesday: "",
        workingThursday: "",
        workingFriday: "",
      },

      ghararToken: "",
    };
  },

  mounted() {
    this.getSetting();
  },

  methods: {
    getSetting() {
      Interview.getSetting()
        .then((response) => {
          this.times.workingSaturday = response.data.data.workingSaturday;
          this.times.workingSunday = response.data.data.workingSunday;
          this.times.workingMonday = response.data.data.workingMonday;
          this.times.workingTuesday = response.data.data.workingTuesday;
          this.times.workingWednesday = response.data.data.workingWednesday;
          this.times.workingThursday = response.data.data.workingThursday;
          this.times.workingFriday = response.data.data.workingFriday;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSubmit(event) {
      event.preventDefault();
      Interview.editSetting(this.times)
        .then(() => {
          this.$swal({
            position: "center",
            icon: "success",
            title: "تنظیمات با موفقیت به روز رسانی شد",
            showConfirmButton: false,
            timer: 3000,
          });

          this.getSetting();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.v-interview-setting {
  padding: 24px;

  table {
    direction: rtl;
    text-align: right;
  }

  &__add-agent {
    .modal-body {
      padding: 16px;
    }

    text-align: right;

    &__header {
      h1 {
      }
    }
  }
}
</style>
